import { render, staticRenderFns } from "./MpPopup.vue?vue&type=template&id=70211988&scoped=true&"
import script from "./MpPopup.vue?vue&type=script&lang=js&"
export * from "./MpPopup.vue?vue&type=script&lang=js&"
import style0 from "./MpPopup.vue?vue&type=style&index=0&id=70211988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70211988",
  null
  
)

export default component.exports